module.exports = __webpack_public_path__ + "877dd820c6e5155f14f81905625a2ccb.png";